import { last, Emitter, normalizeUrl, sleep, stripProtocol } from "@welshman/lib";
import { matchFilters } from "./Filters.js";
// Constants and types
export const LOCAL_RELAY_URL = "local://welshman.relay/";
export const BOGUS_RELAY_URL = "bogus://welshman.relay/";
// Utils related to bare urls
export const isRelayUrl = (url) => {
    if (!url.includes("://")) {
        url = "wss://" + url;
    }
    // Skip non-ws urls
    if (!url.match(/^wss?:\/\//))
        return false;
    // Skip urls with a slash before the dot
    if (url.match(/\\.*\./))
        return false;
    // Skip urls without a dot
    if (!url.match(/\./))
        return false;
    try {
        new URL(url);
    }
    catch (e) {
        return false;
    }
    return true;
};
export const isOnionUrl = (url) => Boolean(stripProtocol(url).match(/^[a-z2-7]{56}.onion/));
export const isLocalUrl = (url) => Boolean(url.match(/\.local(:[\d]+)?\/?$/) || stripProtocol(url).match(/^localhost:/));
export const isIPAddress = (url) => Boolean(url.match(/\d+\.\d+\.\d+\.\d+/));
export const isShareableRelayUrl = (url) => Boolean(isRelayUrl(url) && !isLocalUrl(url));
export const normalizeRelayUrl = (url) => {
    const prefix = url.match(/^wss?:\/\//)?.[0] || (isOnionUrl(url) ? "ws://" : "wss://");
    // Use our library to normalize
    url = normalizeUrl(url, { stripHash: true, stripAuthentication: false });
    // Strip the protocol, lowercase
    url = stripProtocol(url).toLowerCase();
    // Urls without pathnames are supposed to have a trailing slash
    if (!url.includes("/")) {
        url += "/";
    }
    return prefix + url;
};
export const displayRelayUrl = (url) => last(url.split("://")).replace(/\/$/, "");
export const displayRelayProfile = (profile, fallback = "") => profile?.name || fallback;
// In-memory relay implementation backed by Repository
export class Relay extends Emitter {
    repository;
    subs = new Map();
    constructor(repository) {
        super();
        this.repository = repository;
    }
    send(type, ...message) {
        switch (type) {
            case "EVENT":
                return this.handleEVENT(message);
            case "CLOSE":
                return this.handleCLOSE(message);
            case "REQ":
                return this.handleREQ(message);
        }
    }
    handleEVENT([event]) {
        this.repository.publish(event);
        // Callers generally expect async relays
        void sleep(1).then(() => {
            this.emit("OK", event.id, true, "");
            if (!this.repository.isDeleted(event)) {
                for (const [subId, filters] of this.subs.entries()) {
                    if (matchFilters(filters, event)) {
                        this.emit("EVENT", subId, event);
                    }
                }
            }
        });
    }
    handleCLOSE([subId]) {
        this.subs.delete(subId);
    }
    handleREQ([subId, ...filters]) {
        this.subs.set(subId, filters);
        // Callers generally expect async relays
        void sleep(1).then(() => {
            for (const event of this.repository.query(filters)) {
                this.emit("EVENT", subId, event);
            }
            this.emit("EOSE", subId);
        });
    }
}
//# sourceMappingURL=Relay.js.map